import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import ImageWithBasePath from "../../../core/common/imageWithBasePath";
import { RootState } from "../../../core/redux/store";
import { all_routes } from "../../router/all_routes";
import { utils } from "../../../core/helpers/utils";

const ProfileCard = ({buttonTitle}: any) => {
    const user = useSelector((state: RootState) => state.user.user);
    const [avatar, setAvatar] = useState("");

    useEffect(() => {
        setAvatar(utils.getAvatar(user));
    }, [user]);

    return (
        <div className='instructor-profile'>
            <div className='instructor-profile-bg'>
                <ImageWithBasePath src='assets/img/bg/card-bg-01.png' className='instructor-profile-bg-1' alt='' />
            </div>
            <div className='row align-items-center row-gap-3'>
                <div className='col-md-6'>
                    <div className='d-flex align-items-center'>
                        <span className='avatar flex-shrink-0 avatar-xxl avatar-rounded me-3 border border-white border-3 position-relative'>
                            <img src={avatar} alt='img' />
                            <span className='verify-tick'>
                                <i className='isax isax-verify5' />
                            </span>
                        </span>
                        <div>
                            <h5 className='mb-1 text-white d-inline-flex align-items-center'>
                                {user?.name || "User"}
                                {/* <Link to={all_routes.instructorProfile} className='link-light fs-16 ms-2'>
                                    <i className='isax isax-edit-2' />
                                </Link> */}
                            </h5>
                            <br />
                            <span className='text-light'>{utils.capitalize(utils.getRole(user))}</span>
                        </div>
                    </div>
                </div>
                <div className='col-md-6'>
                    <div className='d-flex align-items-center flex-wrap gap-3 justify-content-md-end'>
                        {window.location.pathname === all_routes.home ? (
                            <Link to={all_routes.studentGroups} className='btn btn-secondary rounded-pill'>
                                Cohorts
                                <i className='isax isax-arrow-right-1 ms-2' />
                            </Link>
                        ) :  (
                            <Link to={all_routes.home} className='btn btn-secondary rounded-pill'>
                                {buttonTitle}
                                <i className='isax isax-arrow-right-1 ms-2' />
                            </Link>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ProfileCard;

